import { Component, Input } from '@angular/core';
import { UtilsService } from '../utils/utils.service';

@Component({
  selector: 'app-detail-description',
  templateUrl: './detail-description.component.html',
  styleUrls: ['./detail-description.component.css']
})
export class DetailDescriptionComponent {

  @Input() projection: any;

  constructor(public utilsService:UtilsService){

  }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }

}
